import EventBus from '@/assets/js/eventBus.js'
const linkRegEx = RegExp(/href="<span[^>]*>([^<]*)<\/span>/g)

class SentencePreview {
	element = null

	constructor(sentence, sectionId, variables) {
		this.sentence = sentence
		this.sectionId = sectionId
		this.variables = variables
	}

	get depth() {
		return this.sentence.path.length - 1
	}

	get index() {
		return this.sentence.path[this.sentence.path.length - 1]
	}

	get text() {
		return this.isLeaf ? this.sentence.text.replace(new RegExp('<br/>', 'g'), '\r\n') : ''
	}

	get isLeaf() {
		return this.sentence.text !== undefined
	}

	get isTable() {
		return this.isLeaf ? this.sentence.text.includes("<table>") : false;
	}
	
	get isTableEnd() {
		return this.isLeaf ? this.sentence.text.includes("</table>") : false;
	}

	get sentences() {
		return this.sentence.sentences ? this.sentence.sentences.map(s => new SentencePreview(s, this.sectionId)) : []
	}

	onClick(event) {
		event.stopPropagation()
		EventBus.$emit("closeCta") // To ensure EditorDemoCTA closes if its open
		EventBus.$emit('editSentence', {sentence: this.sentence, element: this.element, sectionId: this.sectionId, variables: this.variables})
	}

	onMouseOver(event) {
		event.stopPropagation()
		EventBus.$emit('previewSentence', {
			sentence: this.sentence,
			element: this.element,
			section: this.sectionId,
			posX: event.clientX,
			posY: event.clientY
		})
	}

	onMouseOut(event) {
		event.stopPropagation()
		EventBus.$emit('stopPreviewingSentence', {sentence: this.sentence, element: this.element})
	}

	// Not in use anynmore. working method in SentencePreviewHtml.vue
	getAsHtml() {
		// Works, but contains empty SPANs
		let el = this.element = document.createElement('span')
		el.setAttribute('depth', this.depth)
		el.setAttribute('index', this.index)
		el.classList.add('preview-sentence-blot')

		// el.addEventListener('mouseover', event => this.onMouseOver(event))
		// el.addEventListener('mouseout', event => this.onMouseOut(event))
		// el.addEventListener('mouseenter', event => this.onMouseOver(event))
		// el.addEventListener('mouseleave', event => this.onMouseOut(event))
		el.addEventListener('click', event => this.onClick(event))

		if (this.isLeaf) { 
			el.innerHTML = this.text
			.replace(/variable-name/g, 'variable-name tooltip')
			.replace(linkRegEx, "href=\"$1")
			+ ' '
		}
		else this.sentences.forEach(s => el.appendChild(s.getAsHtml()))
		return el
	}

	getAsString() {
		if (this.isLeaf) return this.text + ' '
		else return this.sentences.map(s => s.getAsString()).join('')
	}
}

export default SentencePreview
